import { ModalId } from "../../../../enums/modalId";
import {
  setMetaData,
  setOpenedModalId,
} from "../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../redux/store/store";
import {
  createFinalModalMetadata,
  createInitialModalMetadata,
} from "./createModalMetadata";
import { fetchGiData } from "./fetchGiData";
import { fetchProcessedOrdersData } from "./fetchProcessedOrdersData";

export const handleOrdersProcessingInfoClick = async (
  dispatch: AppDispatch,
) => {
  try {
    dispatch(
      setOpenedModalId({
        id: ModalId.ORDER_PROCESSING_INFO_MODAL,
        metaData: createInitialModalMetadata(),
      }),
    );

    const [giData, processedOrdersData] = await Promise.all([
      fetchGiData(),
      fetchProcessedOrdersData(),
    ]);

    dispatch(
      setMetaData(createFinalModalMetadata(giData, processedOrdersData)),
    );
  } catch (error) {
    console.error("Error handling orders processing info click:", error);
    dispatch(
      setMetaData({
        tabs: [],
      }),
    );
  }
};
